import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 7099FDF8-B653-4C49-BE2B-5B96147A709D
 * name signal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalIcon = createSvgIcon(<><path d="M3,21H6V18H3M8,21H11V14H8M13,21H16V9H13M18,21H21V3H18V21Z" /></>, 'SignalIcon');
export default SignalIcon